import {type Directive, type DirectiveBinding, type VNode} from 'vue';
import store from '../store';
import {state as clipboardState} from '../store/modules/clipboard';

function exec(element: HTMLElement, binding: any): boolean
{
    if (binding.value.entries === null)
    {
        return false;
    }

    if (element instanceof HTMLInputElement)
    {
        let data              = checkState(binding.value, binding.value.field || 'active');
        element.checked       = false;
        element.indeterminate = false;

        if ('checked' === data.state)
        {
            element.checked = true;
        }
        else if ('indeterminate' === data.state)
        {
            element.indeterminate = true;
        }

        if (binding.value.clipboardClass)
        {
            let storeValue = clipboardState.selectedItems[binding.value.clipboardClass] || [];

            if (storeValue.length !== data.checkedIds.length || JSON.stringify(storeValue) !== JSON.stringify(data.checkedIds))
            {
                store.commit('clipboard/set', {
                    className: binding.value.clipboardClass,
                    checkedIds: data.checkedIds,
                });
            }
            else
            {
                return false;
            }
        }

        return true;
    }
    else
    {
        throw new Error('Invalid HTML element');
    }
}

function checkState(bindingValue: any, field: string): { state: string, checkedIds: number[] }
{
    let checked: boolean      = false;
    let unchecked: boolean    = false;
    let hasClipboard: boolean = !!(bindingValue.clipboardClass && bindingValue.clipboardIdField);
    let checkedIds            = [];
    let state: string;

    for (let entry of bindingValue.entries)
    {
        if (entry[field])
        {
            checked = true;
        }
        else
        {
            unchecked = true;
        }

        if (hasClipboard && entry[field])
        {
            checkedIds.push(entry[bindingValue.clipboardIdField]);
        }

        if (!hasClipboard && checked && unchecked)
        {
            break;
        }
    }

    if (checked && unchecked)
    {
        state = 'indeterminate';
    }
    else if (checked)
    {
        state = 'checked';
    }
    else
    {
        state = 'unchecked';
    }

    return {
        state,
        checkedIds,
    };
}

function initListener(element: HTMLElement, binding: DirectiveBinding, vNode: VNode)
{
    // initialize checked field in entries where not exists (to prevent duplicate each on single checkbox change)
    let field = binding.value.field || 'active';
    for (let entry of binding.value.entries)
    {
        if (typeof entry[field] === 'undefined')
        {
            entry[field] = false;
        }
    }

    return () =>
    {
        console.debug('[IndeterminateCheckbox] checkbox changed');
        // prevent update each
        element._vPortunaIndeterminate = true;

        let data        = checkState(binding.value, field);
        let value       = 'checked' !== data.state;
        data.checkedIds = [];

        for (let entry of binding.value.entries)
        {
            if (entry[field] !== value)
            {
                entry[field] = value;
            }
            if (entry[field])
            {
                data.checkedIds.push(entry[binding.value.clipboardIdField]);
            }
        }

        if (binding.value.clipboardClass)
        {
            store.commit('clipboard/set', {
                className: binding.value.clipboardClass,
                checkedIds: data.checkedIds,
            });

            vNode.component?.proxy?.$emit('v-indeterminate-checkbox:updated');
        }
    };
}

/**
 * @deprecated use <indeterminate-checkbox> component
 */
const indeterminateCheckbox: Directive = {
    mounted(element: HTMLElement, binding: DirectiveBinding, vNode: VNode)
    {
        element._vPortunaIndeterminate         = true;
        element._vPortunaIndeterminateListener = initListener(element, binding, vNode);
        element.addEventListener('change', element._vPortunaIndeterminateListener);

        if (binding.value.clipboardClass)
        {
            console.debug('[IndeterminateCheckbox] init clipboard');
            store.commit('clipboard/init', binding.value.clipboardClass);
        }
    },
    updated(element: HTMLElement, binding: DirectiveBinding, vNode: VNode)
    {
        // recreate listener
        if (element._vPortunaIndeterminateListener)
        {
            element.removeEventListener('change', element._vPortunaIndeterminateListener);
            element._vPortunaIndeterminateListener = initListener(element, binding, vNode);
            element.addEventListener('change', element._vPortunaIndeterminateListener);
        }

        // prevent useless each for main checkbox click/change or on bind
        if (element._vPortunaIndeterminate)
        {
            element._vPortunaIndeterminate = false;
        }
        else
        {
            console.debug('[IndeterminateCheckbox] directive value updated');
            if (exec(element, binding))
            {
                vNode.component?.proxy?.$emit('v-indeterminate-checkbox:updated');
            }
        }
    },
};

export default indeterminateCheckbox;